const el = {
  h1: document.querySelector('h1.title'),
  description: document.querySelector('h2.description'),
  subcategoriesBox: document.querySelector('[data-panel="subcategories"]'),
  mastercategoriesBox: document.querySelector('[data-panel="mastercategories"]'),
  allSubcategoriesElement: document.querySelector('[data-panel="subcategories"] [data-element="all-subcategories"]'),
  articlesContainer: document.querySelector('[data-component="articles-list-filtered"]'),
  searchBtn: document.querySelector('[data-action="search"]'),
  searchInput: document.querySelector('[data-element="search-box"] input'),
  skeleton: document.querySelector('.skeleton-loader'),
  mobSearchBtn: document.querySelector('.mob.search-btn'),
  mobFiltersBtn: document.querySelector('.mob.filters-btn'),
}

let filters = JSON.parse(el.articlesContainer.dataset.filters);
let mastercategory = el.articlesContainer.dataset.mastercategory;
let prev_mastercategory = mastercategory;


function manageSubcategories() {
  el.subcategoriesBox.querySelectorAll('[data-element="subcategory-value"]').forEach(function (element) {

    element.addEventListener('click', function (e) {
      e.preventDefault();

      let filterValue = element.dataset.value;
      let all_subcategories = el.allSubcategoriesElement.dataset.value.split(',');
      prev_mastercategory = mastercategory;

      el.allSubcategoriesElement.classList.remove('selected');
      el.h1.classList.add('skeleton');
      el.description.classList.add('skeleton');

      /**
       * If all subcategories are selected - i.e. /blog/mba-preparation
       */
      if (filters['category']) {
        var selected_cat = filters['category'].split(',');

        if(arraysEqualUnordered(selected_cat, all_subcategories)){
          delete filters['category'];
        }
      }

      /**
       * Add/Remove value to/from category filter
       */
      if (filters['category']) {
        var selected_categories = filters['category'].split(',');

        if (selected_categories.indexOf(filterValue) > -1) { //already in selected subcategories

          selected_categories = selected_categories.filter(element => element !== filterValue);
          filters['category'] = selected_categories.join(',');
          element.classList.remove('selected');

          if (filters['category'] == '') {
            delete filters['category'];
            el.allSubcategoriesElement.classList.add('selected');
          }

        } else {

          filters['category'] += ',' + filterValue;
          element.classList.add('selected');

          // if all subcategories are selected
          let new_subcategories = filters['category'].split(',');
          if(arraysEqualUnordered(new_subcategories, all_subcategories)){
            delete filters['category'];
            el.allSubcategoriesElement.classList.add('selected');
            el.subcategoriesBox.querySelectorAll('[data-element="subcategory-value"]').forEach(ell => ell.classList.remove('selected'));
          }

        }
      } else {
        filters['category'] = filterValue;
        element.classList.add('selected');
      }

      filters.page ? delete filters.page : true;
      filters['_orderby'] ? delete filters['_orderby'] : true;

      const url = constructUrl('/blog', filters, setUrlParameter);
      getArticles(url);
    });
  })
}

function manageAllSubcategories() {
  el.allSubcategoriesElement.addEventListener('click', function (event) {
    event.preventDefault();

    event.target.parentNode.classList.add('selected');
    el.h1.classList.add('skeleton');
    el.description.classList.add('skeleton');

    // el.allSubcategoriesElement.classList.add('selected');

    delete filters['category'];

    el.subcategoriesBox.querySelectorAll('[data-element="subcategory-value"]').forEach(ell => ell.classList.remove('selected'));

    const url = constructUrl('/blog', '', setUrlParameter);

    getArticles(url);
  })
}


function manageMastercategories() {
  el.mastercategoriesBox.querySelectorAll('[data-element="filter-value"]').forEach(function (element) {
    element.addEventListener('click', function (e) {
        e.preventDefault();
        prev_mastercategory = mastercategory;
        mastercategory = element.dataset.value;

        delete filters['category'];
        el.searchInput.value = '';
        el.allSubcategoriesElement.classList.add('selected');
        el.h1.classList.add('skeleton');
        el.description.classList.add('skeleton');

        el.subcategoriesBox.querySelectorAll('[data-element="subcategory-value"]').forEach(ell => ell.classList.add('skeleton'));

        /**
         * Mark mastercategory as selected
         */
        el.mastercategoriesBox.querySelectorAll('[data-element="filter-value"]').forEach(ell => ell.parentNode.classList.remove('selected'));
        element.parentNode.classList.add('selected');

        const url = constructUrl('/blog', '', setUrlParameter);

        getArticles(url);

    })
  })

}


function pagination() {
  Array.from(el.articlesContainer.querySelectorAll('[data-element="pagination-link"]')).forEach(function (element) {

    if (element.dataset.eventPaginate) {
      return true;
    }

    element.dataset.eventPaginate = true;

    element.addEventListener('click', function (event) {

      event.preventDefault();
      
      el.h1.classList.remove('skeleton');
      el.description.classList.remove('skeleton');

      element.dataset.page == 1 ? delete filters.page : filters.page = element.dataset.page;

      if (element.parentNode.classList.contains('active')) {
        return true;
      }

      const url = constructUrl('/blog', filters, setUrlParameter);
      getArticles(url);

      scroll({ top: 0, left: 0, behavior: "smooth", });
    });
  });
}

function createNewSubCategoryElFromResult(subcategory) {
  const newAncor = document.createElement('a');
  newAncor.textContent = subcategory.title;
  newAncor.setAttribute('class', 'popular-filter');
  newAncor.setAttribute('data-filter', 'category');
  newAncor.setAttribute('data-element', 'subcategory-value');
  newAncor.setAttribute('data-value',  subcategory.unique_key);

  newAncor.setAttribute('href', subcategory.url);

  el.subcategoriesBox.appendChild(newAncor);
}

function getArticles(url) {

  el.skeleton?.classList.add('active');

  fetch(url, {
    method: 'GET',
    mode: "cors",
    credentials: "same-origin",
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    }
  })
    .then(response => response.json())
    .then(function (result) {
      mastergategory = result.mastercategory;
      el.skeleton?.classList.remove('active');

      if (prev_mastercategory != mastercategory ) {
        Array.from(el.subcategoriesBox.querySelectorAll('a[data-filter="category"]'))?.forEach(oldSubcategory => oldSubcategory.remove());

        if(result.subcategories && result.subcategories.length > 0){ //changing subcategories
          document.querySelector('.popular-filters-wrapper').classList.remove('hidden');
          result.subcategories?.forEach(createNewSubCategoryElFromResult);

          el.allSubcategoriesElement.setAttribute('data-value', result.mastercategory_children);
          el.allSubcategoriesElement.setAttribute('href', '/blog/' + result.mastercategory);

          manageSubcategories();
        } else {
          document.querySelector('.popular-filters-wrapper').classList.add('hidden');
        }

        el.description.innerHTML = "";
      }

      if (result.h1 && result.h1 != "") {
        el.h1.innerHTML = result.h1;
      }

      if (result.descr && result.descr != "") {
        el.description.innerHTML = result.descr;
      }

      if (result.html && result.html.trim() !== '') {
        el.articlesContainer.innerHTML = result.html;

        pagination();

        return true
      }

      /**
       * Set an error message when the source did not return any results
       */
      return el.articlesContainer.innerHTML = 'Sorry, the list is empty at the moment';
    })
    .catch(function (error) {
      el.skeleton?.classList.remove('active');
      return error ? el.articlesContainer.innerHTML = error : el.articlesContainer.innerHTML = 'Sorry, we were unable to load the information from the source'
    });

}

function setUrlParameter(uri, key, value) {

  let index = uri.indexOf('#');
  let fragment = index === -1 ? '' : uri.substring(index);
  uri = index === -1 ? uri : uri.substring(0, index);

  let expression = new RegExp("([?&])" + key + "=.*?(&|$)", "i");

  let separator = uri.indexOf('?') !== -1 ? "&" : "?";

  if (uri.match(expression)) {
    uri = uri.replace(expression, '$1' + key + "=" + value + '$2');
  } else {
    uri = uri + separator + key + "=" + value;
  }

  return uri + fragment;
}

function constructUrl(path, filters, setURLfn) {
  if(mastercategory != ''){
      path = path + "/" + mastercategory;
  }

  /**
   * Append the categoties for the fetch
   */
  if (Object.keys(filters).length) {
      if ('category' in filters) {
        let category = filters['category'].split(',');
        if (category.length == 1) {
          // if (mastercategory != '') {
          //     path = path + "/" + mastercategory;
          // }
          path = path + "/" + filters.category;
        }
      }

      Object.keys(filters).forEach(key => {
        if (key == 'category' ) {
          let value = filters[key].split(',')
          if (value.length == 1) {
            return;
          }
        }

        if (key !== '_orderby' && key !== 'mastercategory') {
          path = setURLfn(path, key, filters[key]);
        }
      });
  }

  /**
   *  Използвайте pushState или hashchange за промяна на URL адреса при AJAX взаимодействия; 
   *  Но не и при смяна на ordering i direction
   */
  // if (filters['_orderby']) {
  //   path = setURLfn(path, '_orderby', filters['_orderby'])
  // } else {
    window.history.pushState({}, '', path);
  // }
  
  path = setURLfn(path, 'requested_via', 'ajax');

  return path
}

function searchURLManipulation(inputValue, isClear) {
if (inputValue.trim()) {
  filters = { search: encodeURIComponent(inputValue) };

  if (!isClear) {
    Array.from(document.querySelectorAll('[data-element="filter-value"]')).forEach(function (element) {
      element.parentElement.classList.remove('selected');
    })
  }

  el.mobSearchBtn.classList.add('solid');

} else {
  delete filters.search;
  el.mobSearchBtn.classList.remove('solid');
}

// inputValue.trim() ? filters = { search: encodeURIComponent(inputValue) } : delete filters.search;

mastercategory = '';
const url = constructUrl('/blog', filters, setUrlParameter);
getArticles(url);
}

function searchArticles() {

document.querySelector('.search-box .clear').addEventListener('click', function (e) {
  el.searchInput.value = '';
  e.currentTarget.classList.replace('show', 'hidden');
  searchURLManipulation('', true);
});

el.searchBtn.addEventListener('click', function (e) {
  e.preventDefault();

  if (!(filters.search || el.searchInput.value.trim())) {
    return
  }

  searchURLManipulation(el.searchInput.value)
});

el.searchInput.addEventListener("keypress", function (event) {

  if (event.key === "Enter") {
    event.preventDefault();

    if (!(filters.search || el.searchInput.value.trim())) {
      return
    }

    searchURLManipulation(el.searchInput.value)
  }
});

el.searchInput.addEventListener('keyup', function (e) {

  if (e.target.value.trim() === '') {
    document.querySelector('.search-box .clear').classList.replace('show', 'hidden');
  } else {
    document.querySelector('.search-box .clear').classList.replace('hidden', 'show');
  }
});

}

document.addEventListener('DOMContentLoaded', function (e) {
  manageSubcategories();
  manageAllSubcategories();
  manageMastercategories();
  searchArticles();
  pagination();
})

const countElements = arr => arr.reduce((acc, val) => (acc[val] = (acc[val] || 0) + 1, acc), {});

const arraysEqualUnorderedWithDuplicates = (a, b) => {
  if (a.length !== b.length) return false;
  const countA = countElements(a);
  const countB = countElements(b);
  return Object.keys(countA).every(key => countA[key] === countB[key]);
};


const arraysEqualUnordered = (a, b) => 
  a.length === b.length && [...a].sort().every((val, index) => val === [...b].sort()[index]);


// Reload page when you click back button in browser
window.addEventListener('popstate', (e) => window.location.reload())